export const menuAdminItems = () => {
    const cabecalho = {
        id: 999,
        label: "Administração",
        isTitle: true
    };
    const itensAdmin = [
        {
            id: 9989,
            label: "Empresas",
            icon: "bx-buildings",
            link: "/admin/pessoas/autorizadas",
            empresaRequired: false
        },
        {
            id: 9990,
            label: "Nota Fiscal - NFS-e",
            icon: "bx-list-check",
            empresaRequired: false,
            parentId: 999,
            subItems: [
                {
                    id: 99901,
                    label: "Consultar NFS-e",
                    link: "/admin/nfse/consulta",
                    parentId: 9990
                },
                {
                    id: 99902,
                    label: "Cancelamento",
                    link: "/admin/gestao/pedidos_cancelamento",
                    parentId: 9990
                },
            ]
        },
        {
            id: 99991,
            label: "Usuários",
            icon: "bx-group",
            empresaRequired: false,
            parentId: 999,
            subItems: [
                {
                    id: 999911,
                    label: "Confirmados",
                    link: "/admin/pessoas/usuarios",
                    parentId: 99991,
                },
                {
                    id: 999912,
                    label: "Sem Confirmação",
                    link: "/admin/pessoas/usuarios/sem_confirmacao",
                    parentId: 99991,
                }
            ]
        },
        {
            id: 99992,
            label: "Gestão do ISS",
            icon: "bx-wallet-alt",
            empresaRequired: false,
            parentId: 999,
            subItems: [
                {
                    id: 999922,
                    label: "Fechamento Mensal",
                    link: "/admin/gestao/fechamento",
                    parentId: 99992
                },
                {
                    id: 999923,
                    label: "DUAMs Emitidas",
                    link: "/admin/gestao/duams_emitidas",
                    parentId: 99992,
                    boleto: true
                },
                {
                    id: 999924,
                    label: "Retorno de Pagamento",
                    link: "/admin/gestao/retorno_pagamento",
                    parentId: 99992,
                    boleto: true
                },
            ]
        },
        {
            id: 9991,
            label: "Liberações",
            icon: "bx-check-square",
            empresaRequired: false,
            parentId: 999,
            subItems: [
                {
                    id: 99912,
                    label: "Empresas/Autonômos",
                    link: "/admin/liberacao/pessoa",
                    parentId: 9991
                },
            ]
        },
        {
            id: 99993,
            label: "Remessa TSE",
            icon: "bx-folder-open",
            link: "/admin/gestao/remessa_tse",
            empresaRequired: false
        },
        {
            id: 999991,
            label: "Configurações",
            icon: "bx-wrench",
            parentId: 999,
            empresaRequired: false,
            subItems: [
                {
                    id: 9999912,
                    label: "Geral",
                    link: "/admin/configuracoes/geral",
                    parentId: 999991
                },
            ]
        },
    ]
    return {
        cabecalho: cabecalho,
        itensAdmin: itensAdmin
    }
}









